import { render, staticRenderFns } from "./LeftMenuItem.vue?vue&type=template&id=bf0179e2&scoped=true&"
import script from "./LeftMenuItem.vue?vue&type=script&lang=js&"
export * from "./LeftMenuItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf0179e2",
  null
  
)

export default component.exports